import { FaFileContract } from "react-icons/fa";
import DropdownItemBase from "./DropdownItemBase";

const DropdownItemAlvara = ({ notif, onClick }) => {
    const info = notif.prestador_info;
    if (!info) return null;

    const dias = info.dias_para_vencimento;
    const diasTexto = dias === 1 ? "dia" : "dias";
    const corIcone = dias <= 5 ? "text-danger" : dias <= 15 ? "text-warning" : "text-primary";

    const descricao = (
        <>
            <strong>{info.nome}</strong>
            {info.programa_nome && <span className="text-muted"> · {info.programa_nome}</span>}
            {info.data_vencimento_alvara && (
                <span> — vence em {info.data_vencimento_alvara}</span>
            )}
        </>
    );

    return (
        <DropdownItemBase
            icon={<FaFileContract />}
            text={corIcone}
            titulo={`Alvará vencendo em ${dias} ${diasTexto}`}
            descricao={descricao}
            dataFormatada=""
            onClick={() => onClick(notif)}
        />
    );
};

export default DropdownItemAlvara;
